import { Injectable } from '@angular/core';
import { TeaLogUtil } from './tealog.utility';


@Injectable({
  providedIn: 'root'
})
export class TeaLogService extends TeaLogUtil{

}